import React from 'react';
import {
    Col,
    Row,
    Modal,
    ModalHeader,
    ModalBody,
    Input,
    Button,
    Progress,
    Label,
} from "reactstrap";
import ToastHelper from '../../helpers/ToastHelper';
import { AvForm, AvField } from "availity-reactstrap-validation";
import { useMutation } from 'react-apollo';
import { useQuery } from '@apollo/react-hooks';
import { GET_ENUM } from '../../graphql/query';
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import Compressor from 'compressorjs';
import CloudinaryHelper from "../../helpers/CloudinaryHelper"
import { FormGroup } from '@material-ui/core';
import DropZone from '../Workbench/Components/drop-zone';
import { UPDATE_ONE_MARKETING_CAMPAIGN } from '../../graphql/mutation';
import DatePicker from "react-datepicker";
import moment from 'moment';

function EditCampaign(props) {

    const { modal, toggleModal, t, campaign } = props;
    const [selectedFile, setSelectFile] = React.useState(null);
    const [fileError, setFileError] = React.useState(null);
    const [onUpload, setOnUpload] = React.useState(false);
    const [progress, setProgress] = React.useState(0);
    const [medium, setMedium] = React.useState("")
    const [fromDate, setFromDate] = React.useState(moment(campaign.node.startAt).startOf("day").toDate())
    const [toDate, setToDate] = React.useState(moment(campaign.node.endAt).endOf("day").toDate())
    const [existingFile, setExistingFile] = React.useState(null);
    const [currentImage, setCurrentImage] = React.useState(null)

    const { data: mediumData } = useQuery(GET_ENUM, {
        variables: {
            name: "MarketingCampaignMedium"
        }
    });

    const { data: languageData } = useQuery(GET_ENUM, {
        variables: {
            name: "Language"
        }
    });

    const [updateOneCampaign] = useMutation(UPDATE_ONE_MARKETING_CAMPAIGN);

    React.useEffect(() => {
        setSelectFile(null)
        setFileError(null)
        setProgress(0)
        setOnUpload(false)

        if (modal) {
            setExistingFile(campaign.node.mediaLink)
            setCurrentImage(campaign.node.mediaLink)
            setMedium(campaign.node.marketingCampaignMedium)
        }
    }, [modal]) // eslint-disable-line react-hooks/exhaustive-deps

    const Compress = (file) => {
        const fileType = file['type'];
        const validImageTypes = ['image/jpeg', 'image/png'];
        if (!validImageTypes.includes(fileType)) {
            return file
        }

        return new Promise((resolve, reject) => {
            new Compressor(file, {
                quality: 1,
                success: resolve,
                error: reject
            });
        })
    }

    const GetLanguage = (lang) => {
        if (lang == null) {
            return "All Language"
        } else if (lang == "EN") {
            return "English"
        } else if (lang == "MS") {
            return "Malay"
        } else if (lang == "ZH") {
            return "Chinese"
        }
    }

    return (
        <React.Fragment>
            <Modal isOpen={modal} role="dialog" size="lg" autoFocus={true} centered={true} id="verificationModal" tabIndex="-1" toggle={toggleModal}>
                <div className="modal-content new-bonus-page">
                    <ModalHeader toggle={toggleModal}>
                        Edit Campaign
                    </ModalHeader>
                    <ModalBody>
                        <div id="new-bank-wizard" className="twitter-bs-wizard">
                            <AvForm className="needs-validation"
                                onValidSubmit={async (event, values) => {
                                    let result
                                    if (selectedFile) {
                                        setOnUpload(true)
                                        let imageData = await Compress(selectedFile)
                                        result = await CloudinaryHelper.upload(imageData, `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload?upload_preset=v13sqvvy`, (progressEvent) => {
                                            let val = Math.round((progressEvent.loaded / progressEvent.total) * 100)
                                            setProgress(val)
                                        })
                                        setOnUpload(false)
                                    }
                                    setOnUpload(false)
                                    await updateOneCampaign({
                                        variables: {
                                            input: {
                                                update: {
                                                    name: values.campaignName,
                                                    mediaLink: selectedFile ? result.data.url : currentImage ? currentImage : null,
                                                    message: values.message,
                                                    startAt: values.fromDate,
                                                    endAt: values.toDate,
                                                    marketingCampaignMedium: values.campaignMedium,
                                                    targetingLanguage: (values.targetingLanguage == "All Language" || values.targetingLanguage == "") ? null : values.targetingLanguage
                                                },
                                                id: campaign.node.id
                                            }
                                        }
                                    }).catch(e => {
                                        ToastHelper.toggleToast({
                                            toastType: "error",
                                            message: e,
                                            title: "",
                                            onClick: function () { }
                                        })
                                    }).then(val => {
                                        if (val) {
                                            ToastHelper.toggleToast({
                                                message: "Update Succesfully!",
                                                title: "",
                                                onClick: function () { }
                                            })
                                            toggleModal()
                                        }
                                    })
                                }}
                                onInvalidSubmit={() => {

                                }}
                            >
                                <Row>
                                    {
                                        medium !== "SMS" &&
                                        <Col lg={12}>
                                            <DropZone
                                                selectedFile={selectedFile}
                                                onFileDrop={(file) => {
                                                    setSelectFile(file)
                                                    setExistingFile(null)
                                                }}
                                                currentImage={existingFile}
                                            />
                                        </Col>
                                    }
                                    {
                                        fileError &&
                                        !selectedFile &&
                                        <Col lg="12"><div className="image-url-error pb-2 font-size-10">* Please Provide an Image</div></Col>
                                    }
                                    {
                                        onUpload &&
                                        <Col lg={12}>
                                            <FormGroup className="mb-3">
                                                <Label>Uploading</Label>
                                                <Progress color="primary" value={progress}></Progress>
                                            </FormGroup>
                                        </Col>
                                    }
                                    <Col lg={6}>
                                        <AvField
                                            value={campaign.node.name}
                                            label="Campaign Name"
                                            name="campaignName"
                                            type="text"
                                            placeholder="Enter Campaign Name"
                                            errorMessage="Enter Campaign name"
                                            validate={{
                                                required: { value: true },
                                            }}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <AvField
                                            value={campaign.node.marketingCampaignMedium}
                                            type="select"
                                            name="campaignMedium"
                                            className="custom-select"
                                            label={t('Campaign Medium')}
                                            onChange={(e) => {
                                                setMedium(e.target.value)
                                                setSelectFile(null)
                                            }}
                                        >
                                            {
                                                mediumData &&
                                                mediumData.__type.enumValues.map(({ name }, index) => {
                                                    return (
                                                        <option key={index} value={name}>{name}</option>
                                                    )
                                                })
                                            }
                                        </AvField>
                                    </Col>
                                    <Col lg={6}>
                                        <AvField
                                            value={fromDate}
                                            selected={fromDate}
                                            label="Start Date"
                                            name="fromDate"
                                            type="text"
                                            placeholderText="Enter Start Date"
                                            errorMessage="Enter Start Date"
                                            selectsStart
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="yyyy-MM-dd"
                                            tag={[Input, DatePicker]}
                                            onChange={date => {
                                                setFromDate(date)
                                            }}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <AvField
                                            value={toDate}
                                            selected={toDate}
                                            label="End Date"
                                            name="toDate"
                                            type="text"
                                            placeholderText="Enter End Date"
                                            errorMessage="Enter End Date"
                                            selectsStart
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            dateFormat="yyyy-MM-dd"
                                            tag={[Input, DatePicker]}
                                            minDate={fromDate}
                                            onChange={date => {
                                                setToDate(date)
                                            }}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <AvField
                                            value={campaign.node.targetingLanguage}
                                            type="select"
                                            name="targetingLanguage"
                                            className="custom-select"
                                            label={t('Targeting Langauge')}
                                        >
                                            <option key={"-1"} value={"All Language"}>All Language</option>
                                            {
                                                languageData &&
                                                languageData.__type.enumValues.map(({ name }, index) => {
                                                    return (
                                                        <option key={index} value={name}>{GetLanguage(name)}</option>
                                                    )
                                                })
                                            }
                                        </AvField>
                                    </Col>
                                    <Col lg={12}>
                                        <AvField
                                            value={campaign.node.message}
                                            label="Message"
                                            name="message"
                                            type="textarea"
                                            placeholder="Enter Campaign Message"
                                            errorMessage="Enter Campaign Message"
                                        />
                                    </Col>
                                </Row>
                                {
                                    !onUpload &&
                                    <div className="action-container">
                                        <Button color="primary" type="submit">Submit</Button>
                                    </div>
                                }
                            </AvForm>
                        </div>
                    </ModalBody>
                </div>
            </Modal>
        </React.Fragment >
    );
}

export default connect()(withTranslation()(EditCampaign));